import { render, staticRenderFns } from "./Therapist.vue?vue&type=template&id=ad0ebd24&scoped=true&"
import script from "./Therapist.vue?vue&type=script&lang=js&"
export * from "./Therapist.vue?vue&type=script&lang=js&"
import style0 from "./Therapist.vue?vue&type=style&index=0&id=ad0ebd24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0ebd24",
  null
  
)

export default component.exports